export enum DEPOSIT_LIMITS_PREDEFINED_TYPE {
    DISABLED = 'disabled',
    ENABLED = 'enabled',
    FORCED = 'forced'
}
